import CustomFormComponent from './custom-form-component.vue';

export default { CustomFormComponent };
